import axios from "axios";
// const qs = require('qs');

// import Vue from 'vue'
import service from '@/utils/request.js'
// import { reject, resolve } from "core-js/fn/promise";
// let url = 'http://192.168.50.125:8500/api/product/2.5'
// let url = 'http://h5.gamedachen.com/dcapi/api/product/2.5' //正式
// http://app.game683.com/api/product/2.5
// let url = 'http://test-app.gamedachen.com/api/api/product/2.5' //测试

export function getGameDetail(id) {
    return service({
            url: '/api/product/2.5/' + id,
            method: 'get'
        })
        // return new Promise((resolve, reject) => {
        //     axios.get(url + `/${id}`).then(res => {
        //         resolve(res.data)
        //     })
        // })
}